import type { IconSvgObject } from './types';

const ChevronDownIcon: IconSvgObject = [
  ["path", { d: "M6 9L12 15L18 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ChevronDownIcon;
